import { createSelector } from 'reselect';
import get from 'lodash/get';
import nullableDownPaymentSelector from '../MortgageWorkflow/Steps/DownPayment/DownPaymentSelector';
import {
  nullableMortgageTypeSelector,
  hasMortgageSelector,
  nullableMortgageInterestRateSelector,
  nullableMortgagePMISelector,
} from '../MortgageWorkflow/Steps/Mortgage/MortgageSelector';

import { nullableMarketValueSelector } from './Steps/HomeEstimatedValue/HomeEstimatedValueSelector';
import {
  nullableDesiredPurchaseYearSelector,
  nullablePurchaseAtRetirementSelector,
} from './Steps/YearHomePurchase/YearHomePurchaseSelector';
import { graphDataOrEmptyObjectSelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from './HomePurchaseWorkflowConstants';

const isHomePurchaseGoalValidSelector = createSelector(
  nullableMarketValueSelector,
  nullableDesiredPurchaseYearSelector,
  nullablePurchaseAtRetirementSelector,
  nullableDownPaymentSelector,

  hasMortgageSelector,
  nullableMortgageTypeSelector,
  nullableMortgageInterestRateSelector,
  nullableMortgagePMISelector,
  (
    nullableMarketValue,
    nullableDesiredPurchaseYear,
    nullablePurchaseAtRetirement,
    nullableDownPayment,
    hasMortgage,
    nullableMortgageType,
    nullableMortgageInterestRate,
    nullableMortgagePMI,
  ) => {
    if (nullableMarketValue === null) {
      return false;
    }

    if (nullablePurchaseAtRetirement === null) {
      return false;
    }

    if (nullablePurchaseAtRetirement === false) {
      if (nullableDesiredPurchaseYear === null) {
        return false;
      }
    }

    if (nullableDownPayment === null) {
      return false;
    }

    if (hasMortgage) {
      if (nullableMortgageType === null) {
        return false;
      }
      if (nullableMortgageInterestRate === null) {
        return false;
      }
      if (nullableMortgagePMI === null) {
        return false;
      }
    }

    return true;
  },
);

export default isHomePurchaseGoalValidSelector;

export const nullableGoalIdSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty => get(graphDataOrEmpty, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Id`, null),
);

export const hasHomePurchaseWorkflowData = state => !!state.AdvWorkflow.HomePurchaseWorkflow;
